module.exports = __webpack_public_path__ + "static/media/user.83e697f7.svg";